module.exports = __webpack_public_path__ + "img/qomriah.ec8fd45c.webp";